import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { FitSection } from './components/FitSection';
import { OfferSection } from './components/OfferSection';
export function App() {
  return <main className="min-h-screen bg-cream-50 font-sans selection:bg-sage-200 selection:text-sage-900" data-id="element-0">
      <Hero data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <SolutionSection data-id="element-3" />
      <FitSection data-id="element-4" />
      <OfferSection data-id="element-5" />

      {/* Footer */}
      <footer className="bg-stone-900 text-stone-400 py-8 text-center text-sm" data-id="element-6">
        <div className="max-w-4xl mx-auto px-6" data-id="element-7">
          <p data-id="element-8">
            © {new Date().getFullYear()} Obediencia Sin Gritos. Todos los
            derechos reservados.
          </p>
          <p className="mt-2 text-stone-500" data-id="element-9">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca comercial de FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </main>;
}